"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tborder-collapse: seperate;\n\tborder: 1px solid ", ";\n\tbackground: ", ";\n\tborder-radius: 3px;\n\tborder-spacing: 0;\n"], ["\n\tborder-collapse: seperate;\n\tborder: 1px solid ", ";\n\tbackground: ", ";\n\tborder-radius: 3px;\n\tborder-spacing: 0;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\topacity: ", ";\n\tfont-weight: ", ";\n\n\t&:first-child {\n\t\tth,\n\t\ttd {\n\t\t\t&:first-child {\n\t\t\t\tborder-top-left-radius: 3px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-top-right-radius: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:last-child {\n\t\tth,\n\t\ttd {\n\t\t\t&:first-child {\n\t\t\t\tborder-bottom-left-radius: 3px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom-right-radius: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:nth-child(2n + 1) {\n\t\tbackground: ", ";\n\t}\n"], ["\n\topacity: ", ";\n\tfont-weight: ", ";\n\n\t&:first-child {\n\t\tth,\n\t\ttd {\n\t\t\t&:first-child {\n\t\t\t\tborder-top-left-radius: 3px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-top-right-radius: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:last-child {\n\t\tth,\n\t\ttd {\n\t\t\t&:first-child {\n\t\t\t\tborder-bottom-left-radius: 3px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom-right-radius: 3px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:nth-child(2n + 1) {\n\t\tbackground: ", ";\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tpadding: ", "em ", "em;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"], ["\n\tpadding: ", "em ", "em;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"]),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(["\n\tfont-weight: bold;\n\ttext-align: left;\n\tbackground: ", ";\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\t\n"], ["\n\tfont-weight: bold;\n\ttext-align: left;\n\tbackground: ", ";\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\t\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getters = require("../getters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------------------------------------------

var getHalfPaddingVertical = _ramda2.default.pipe(_getters.getPaddingVertical, _ramda2.default.multiply(0.5));
var getHalfPaddingHorizontal = _ramda2.default.pipe(_getters.getPaddingHorizontal, _ramda2.default.multiply(0.5));

var getGray = _ramda2.default.path(["theme", "colors", "gray"]);
var getDarkGray = _ramda2.default.path(["theme", "colors", "darkgray"]);
var getMidGray = _ramda2.default.path(["theme", "colors", "midgray"]);

// --------------------------------------------------

var TableBody = _styledComponents2.default.table(_templateObject, _ramda2.default.path(["theme", "colors", "gray"]), _ramda2.default.path(["theme", "colors", "lightgray"]));

var TableRow = _styledComponents2.default.tr(_templateObject2, function (props) {
	return props.visible === false ? 0.5 : 1;
}, function (props) {
	return props.bold ? "bold" : "normal";
}, getMidGray);

var TableCell = _styledComponents2.default.td(_templateObject3, getHalfPaddingVertical, getHalfPaddingHorizontal, getGray);

var TableHeaderCell = TableCell.withComponent("th").extend(_templateObject4, getGray, getDarkGray);

// --------------------------------------------------

var Table = function (_React$Component) {
	(0, _inherits3.default)(Table, _React$Component);

	function Table() {
		(0, _classCallCheck3.default)(this, Table);
		return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	}

	(0, _createClass3.default)(Table, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				TableBody,
				null,
				_react2.default.createElement(
					"tbody",
					null,
					this.props.children
				)
			);
		}
	}]);
	return Table;
}(_react2.default.Component);

// --------------------------------------------------

Table.HeaderRow = function (props) {
	return _react2.default.createElement(
		TableRow,
		(0, _extends3.default)({ bold: true }, props),
		_react2.default.Children.map(props.children, function (child) {
			return _react2.default.cloneElement(child, {
				inHeader: true
			});
		})
	);
};

Table.Row = function (props) {
	return _react2.default.createElement(TableRow, props);
};

Table.Cell = function (props) {
	return props.inHeader ? _react2.default.createElement(TableHeaderCell, props) : _react2.default.createElement(TableCell, props);
};

// --------------------------------------------------

exports.default = Table;

//# sourceMappingURL=table.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/table.js
// module id = 382
// module chunks = 0